module.exports = __webpack_public_path__ + "img/icon_register_lock.e8681fe8.svg";